import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { FUNDING_STEP_ACTION } from '../../Funding.actions';
import { FundingStepActionButton } from '../fundingStepActionButton/FundingStepActionButton';
import { TFundingRequirementsSteps } from '../orderFundingRequirements';
import StepItem from '../stepItem/StepItem';

const mapDispatchToProps = (dispatch: Dispatch) => ({
    handleFundingStepAction: () => {
        dispatch({ type: FUNDING_STEP_ACTION, step: 'DEBIT_CARD' });
    }
});

const DebitCardAction = ({
    status,
    handleFundingStepAction
}: {
    status: TFundingRequirementsSteps['0']['status'];
} & ReturnType<typeof mapDispatchToProps>) => {
    return (
        <StepItem
            title={
                <FormattedMessage
                    id="_.funding_requirements.link_debit_card_title"
                    defaultMessage="Link a debit card"
                />
            }
            caption={
                <FormattedMessage
                    id="_.funding_requirements.link_debit_card_caption"
                    defaultMessage="Your repayments will be taken automatically from your debit card."
                />
            }
            action={
                <FundingStepActionButton
                    actionMessage={
                        <FormattedMessage
                            id="_.funding_requirements.link_debit_card_action"
                            defaultMessage="Link card"
                        />
                    }
                    pendingMessage={
                        <FormattedMessage
                            id="_.funding_requirements.link_debit_card_action_pending"
                            defaultMessage="Pending"
                        />
                    }
                    status={status}
                    handleFundingStepAction={handleFundingStepAction}
                    stepName="Debit card"
                />
            }
        />
    );
};
// eslint-disable-next-line import/no-default-export
export default connect(null, mapDispatchToProps)(DebitCardAction);
